import React, { useEffect, useState } from "react";
import axiosInstance from "../../../../axios";
import { Loading } from "../../../Other/Loading";
import { FaBookOpen, FaChalkboardTeacher, FaUsers, FaAward } from "react-icons/fa";

const InstructorListData = () => {
  const [instructorData, setInstructorData] = useState({
    courses: 0,
    completedWebinars: 0,
    students: 0,
    certificates: 0,
    thisMonthCourses: 0,
    thisMonthCompletedWebinars: 0,
    thisMonthStudents: 0,
    thisMonthCertificates: 0,
  });
  const [loading, setLoading] = useState(true);

  const fetch = async () => {
    try {
      const { data: { data: result } } = await axiosInstance.get("instructor/statistics");
      setInstructorData((state) => ({ ...state, ...result }));
    } catch (error) {
      console.error("Error fetching instructor statistics:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetch();
  }, []);

  const cardStyle = (color) => ({
    background: "white",
    borderRadius: "20px",
    padding: "24px",
    border: "1px solid #e2e8f0",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.02)",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    position: "relative",
    overflow: "hidden",
    flex: "1 1 220px",
  });

  return (
    <div 
      style={{ 
        display: "flex",
        flexWrap: "wrap",
        gap: "20px", 
        marginBottom: "24px",
        fontFamily: "'Outfit', sans-serif"
      }}
    >
      {/* Courses */}
      <div
        style={cardStyle("#3b82f6")}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-4px)";
          e.currentTarget.style.boxShadow = "0 12px 20px rgba(59, 130, 246, 0.08)";
          e.currentTarget.style.borderColor = "#3b82f6";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.02)";
          e.currentTarget.style.borderColor = "#e2e8f0";
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start", marginBottom: "16px" }}>
          <div>
            <p style={{ margin: 0, fontSize: "14px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em" }}>Courses</p>
            <h3 style={{ margin: "6px 0 0 0", fontSize: "28px", fontWeight: "800", color: "#0f172a", display: "flex", alignItems: "center" }}>
              {loading ? (
                <span className="skeleton" style={{ width: "60px", height: "28px", borderRadius: "6px" }}></span>
              ) : (
                instructorData.courses
              )}
            </h3>
          </div>
          <div style={{
            background: "#eff6ff",
            color: "#3b82f6",
            width: "44px",
            height: "44px",
            borderRadius: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "20px",
            border: "1px solid #dbeafe"
          }}>
            <FaBookOpen />
          </div>
        </div>
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          paddingTop: "12px",
          borderTop: "1px solid #f1f5f9",
          fontSize: "12px",
          color: "#64748b",
          minHeight: "31px"
        }}>
          {loading ? (
            <span className="skeleton" style={{ width: "35px", height: "18px", borderRadius: "10px" }}></span>
          ) : (
            <span style={{
              background: "#eff6ff",
              color: "#1d4ed8",
              padding: "2px 8px",
              borderRadius: "20px",
              fontWeight: "700",
              fontSize: "11px"
            }}>
              +{instructorData?.thisMonthCourses || 0}
            </span>
          )}
          <span style={{ fontWeight: "600" }}>Added this month</span>
        </div>
      </div>

      {/* Completed Webinars */}
      <div
        style={cardStyle("#10b981")}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-4px)";
          e.currentTarget.style.boxShadow = "0 12px 20px rgba(16, 185, 129, 0.08)";
          e.currentTarget.style.borderColor = "#10b981";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.02)";
          e.currentTarget.style.borderColor = "#e2e8f0";
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start", marginBottom: "16px" }}>
          <div>
            <p style={{ margin: 0, fontSize: "14px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em" }}>Completed Webinars</p>
            <h3 style={{ margin: "6px 0 0 0", fontSize: "28px", fontWeight: "800", color: "#0f172a", display: "flex", alignItems: "center" }}>
              {loading ? (
                <span className="skeleton" style={{ width: "60px", height: "28px", borderRadius: "6px" }}></span>
              ) : (
                instructorData.completedWebinars
              )}
            </h3>
          </div>
          <div style={{
            background: "#ecfdf5",
            color: "#10b981",
            width: "44px",
            height: "44px",
            borderRadius: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "20px",
            border: "1px solid #a7f3d0"
          }}>
            <FaChalkboardTeacher />
          </div>
        </div>
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          paddingTop: "12px",
          borderTop: "1px solid #f1f5f9",
          fontSize: "12px",
          color: "#64748b",
          minHeight: "31px"
        }}>
          {loading ? (
            <span className="skeleton" style={{ width: "35px", height: "18px", borderRadius: "10px" }}></span>
          ) : (
            <span style={{
              background: "#ecfdf5",
              color: "#047857",
              padding: "2px 8px",
              borderRadius: "20px",
              fontWeight: "700",
              fontSize: "11px"
            }}>
              +{instructorData?.thisMonthCompletedWebinars || 0}
            </span>
          )}
          <span style={{ fontWeight: "600" }}>Added this month</span>
        </div>
      </div>

      {/* Students */}
      <div
        style={cardStyle("#6366f1")}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-4px)";
          e.currentTarget.style.boxShadow = "0 12px 20px rgba(99, 102, 241, 0.08)";
          e.currentTarget.style.borderColor = "#6366f1";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.02)";
          e.currentTarget.style.borderColor = "#e2e8f0";
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start", marginBottom: "16px" }}>
          <div>
            <p style={{ margin: 0, fontSize: "14px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em" }}>Students</p>
            <h3 style={{ margin: "6px 0 0 0", fontSize: "28px", fontWeight: "800", color: "#0f172a", display: "flex", alignItems: "center" }}>
              {loading ? (
                <span className="skeleton" style={{ width: "60px", height: "28px", borderRadius: "6px" }}></span>
              ) : (
                instructorData.students
              )}
            </h3>
          </div>
          <div style={{
            background: "#e0e7ff",
            color: "#6366f1",
            width: "44px",
            height: "44px",
            borderRadius: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "20px",
            border: "1px solid #c7d2fe"
          }}>
            <FaUsers />
          </div>
        </div>
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          paddingTop: "12px",
          borderTop: "1px solid #f1f5f9",
          fontSize: "12px",
          color: "#64748b",
          minHeight: "31px"
        }}>
          {loading ? (
            <span className="skeleton" style={{ width: "35px", height: "18px", borderRadius: "10px" }}></span>
          ) : (
            <span style={{
              background: "#e0e7ff",
              color: "#4338ca",
              padding: "2px 8px",
              borderRadius: "20px",
              fontWeight: "700",
              fontSize: "11px"
            }}>
              +{instructorData?.thisMonthStudents || 0}
            </span>
          )}
          <span style={{ fontWeight: "600" }}>Added this month</span>
        </div>
      </div>

      {/* Certificates */}
      <div
        style={cardStyle("#d946ef")}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-4px)";
          e.currentTarget.style.boxShadow = "0 12px 20px rgba(217, 70, 239, 0.08)";
          e.currentTarget.style.borderColor = "#d946ef";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.02)";
          e.currentTarget.style.borderColor = "#e2e8f0";
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start", marginBottom: "16px" }}>
          <div>
            <p style={{ margin: 0, fontSize: "14px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em" }}>Certificates</p>
            <h3 style={{ margin: "6px 0 0 0", fontSize: "28px", fontWeight: "800", color: "#0f172a", display: "flex", alignItems: "center" }}>
              {loading ? (
                <span className="skeleton" style={{ width: "60px", height: "28px", borderRadius: "6px" }}></span>
              ) : (
                instructorData.certificates
              )}
            </h3>
          </div>
          <div style={{
            background: "#fdf4ff",
            color: "#d946ef",
            width: "44px",
            height: "44px",
            borderRadius: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "20px",
            border: "1px solid #f5d0fe"
          }}>
            <FaAward />
          </div>
        </div>
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          paddingTop: "12px",
          borderTop: "1px solid #f1f5f9",
          fontSize: "12px",
          color: "#64748b",
          minHeight: "31px"
        }}>
          {loading ? (
            <span className="skeleton" style={{ width: "35px", height: "18px", borderRadius: "10px" }}></span>
          ) : (
            <span style={{
              background: "#fdf4ff",
              color: "#a21caf",
              padding: "2px 8px",
              borderRadius: "20px",
              fontWeight: "700",
              fontSize: "11px"
            }}>
              +{instructorData?.thisMonthCertificates || 0}
            </span>
          )}
          <span style={{ fontWeight: "600" }}>Added this month</span>
        </div>
      </div>
    </div>
  );
};

export default InstructorListData;
